import { gql } from '@apollo/client';

export const FindManyEvents = gql`
query FindManyEvents ($status: String, $type: String, $seasonId: Int) {
    findManyEvents(status: $status, type: $type, seasonId: $seasonId) {
      id
      name
      mediaThumbnail
      infoMediaThumbnail
      location
      startAt
      registerStartAt
      registerEndAt
      endAt
      status
      level
      type
      categories
      isTerminated
      hasAlreadyJoined
      hasAssignedTrip
      canJoin
    registrationBlockers {
      code
      message
      action
    }
      eventSubtitle
      lessThan14days
      players {
        isConfirmed
        player {
          id
        }
      }
    }
  }
`;

export const FindOneEvent = gql`
query FindOneEvent($id: Int!) {
  findOneEvent(id: $id) {
    id
    name
    media
    infoMedia
    location
    startAt
    registerStartAt
    registerEndAt
    endAt
    status
    level
    type
    categories
    isTerminated
    hasAlreadyJoined
    canJoin
    eventSubtitle
    lessThan14days
    players {
      isConfirmed
      depositProvided
      achievements {
        id
        rank
        category
        weightCategory
        mode
      }
      player {
        id
        firstName
        lastName
        email
        rentals {
          id
          rentalDate
          returnDate
          bag {
            name
          }
        }
        profile {
          pictureThumbnail
          gender
          dateOfBirth
          weights {
            value
            createdAt
          }
        }
      }
    }
    season {
      id
      name
      startDate
      endDate
    }
  }
}`;
